import * as angular from "angular";
import {IController} from "angular";
import {TaskModel} from "../../models/task.model";

export class TaskStatusCtrl implements IController {
  task: TaskModel;
  small: boolean;
}

angular
  .module('bringoz.admin.tasks')
  .component('taskStatus', {
    bindings: {
      task: '<',
      small: '<'
    },
    template: require('./task-status.html').default,
    controller: TaskStatusCtrl

  });
